import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import { vuexfireMutations } from 'vuexfire'
import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'
import user from './modules/user'
import organization from './modules/organization'
import rates from './modules/rates'
import team from './modules/team'
import roles from './modules/roles'
import redFlags from './modules/redFlags'
import estimates from './modules/estimates'
import tasks from './modules/tasks'
import changelog from './modules/changelog'

Vue.use(Vuex)
Vue.use(VueCookies)

const store = new Vuex.Store({
  state: {
    saved: false,
    loading: false,
    redirect: false
  },
  actions,
  getters,
  mutations: {
    ...mutations,
    ...vuexfireMutations
  },
  modules: {
    changelog,
    user,
    organization,
    rates,
    team,
    roles,
    redFlags,
    estimates,
    tasks
  }
})

export default store
